import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addressUpdateError:
      'An error occurred. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    fieldAdditionLabel: 'Street addition',
    fieldAdditionPlaceholder: 'ex: Apt 43',
    fieldCityLabel: 'City',
    fieldCountryLabel: 'Country',
    fieldStreetLabel: 'Street',
    fieldZipCodeLabel: 'Zip code',
    next: 'Confirm my address',
    subtitle:
      'Make sure to include useful information that can help with the delivery (apartment number, name of your host, door code...).',
    title: 'Update your address',
  },
  fr: {
    addressUpdateError:
      'Une erreur est survenue. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    fieldAdditionLabel: 'Complément d’adresse',
    fieldAdditionPlaceholder: 'ex: Apt 43',
    fieldCityLabel: 'Ville',
    fieldCountryLabel: 'Pays',
    fieldStreetLabel: 'Rue',
    fieldZipCodeLabel: 'Code postal',
    next: 'Valider mon adresse',
    subtitle:
      'Assurez-vous d’inclure toute information utile pour faciliter la livraison (numéro d’appartement, nom de votre hébergeur, digicode...).',
    title: 'Modifiez votre adresse',
  },
} as const);

export default locales;
